import Vue from "vue";
import Vuex from "vuex";
import location from './location' // 地理位置全局管理

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    phoneLoginShow: false,
    empowerShow: false,
    loadingShow: false,
    tabBarActive: 0,
    handleTechnicianId:'',    // 点击查看的技师id
  },
  mutations: {
    handleTechnicianId(state, value) {
      state.handleTechnicianId = value; 
    },
    phoneLoginControl(state, value) {
      state.phoneLoginShow = value;
    },
    empowerControl(state, value) {
      state.empowerShow = value;
    },
    loadingControl(state, value) {
      state.loadingShow = value;
    },
    tabBarActiveControl(state, value) {
      state.tabBarActive = value;
    },
  },

  actions: {},
  modules: {
    location 
  }
});
